export default __webpack_public_path__ + "static/default-94c6cf1cdefdbdd0fc62192c830a06a6.png";